import { PaperElevations } from '@/components/Paper'

export const GROUP_NAME = 'dropdown'

export const DEFAULT_ELEVATION = PaperElevations.Bordered
